import { jsx as _jsx } from "react/jsx-runtime";
import { paymentTypes } from '../../../const/paymentOptions';
import Autopay from './Autopay';
import OneTimePayment from './OneTimePayment';
import PayoffPayment from './PayoffPayment';
const PaymentFlow = ({ paymentType, resetTabFocus }) => {
    if (paymentType === paymentTypes.ONCE) {
        return _jsx(OneTimePayment, { resetTabFocus: resetTabFocus });
    }
    if (paymentType === paymentTypes.AUTOPAY) {
        return _jsx(Autopay, { resetTabFocus: resetTabFocus });
    }
    if (paymentType === paymentTypes.PAYOFF) {
        return _jsx(PayoffPayment, { resetTabFocus: resetTabFocus });
    }
    return null;
};
export default PaymentFlow;
